import Breadcrumbs from "@mui/material/Breadcrumbs";
import Skeleton from "@mui/material/Skeleton";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useWorkspaceStore } from "../../../../store/workspace/WorkspaceStore";
import { VIEW_OPTION_NAME } from "../../constants";
import { BreadcrumbItem } from "./components/BreadcrumbItem";

const PATH_BREADCRUMB_MAP: { [key: string]: string } = {
  "customer-profile": "Customer Profile",
  configuration: "Project Configuration",
  "market-sizing": "Market Sizing",
  settings: "Settings",
  competitors: "Competitors",
  whitespace: "Whitespace",
};

export const WorkspaceBreadcrumbs: FC = () => {
  const workspace = useWorkspaceStore((state) => state.persisted);
  const selectedView = useWorkspaceStore((state) => state.selectedView);
  const navigate = useNavigate();

  const handleWorkspacesClick = () => {
    navigate("/projects/my");
  };

  const handleWorkspaceClick = () => {
    if (workspace?.id) {
      navigate(`/projects/${workspace.id}`);
    }
  };

  const lastBreadcrumbLabel = VIEW_OPTION_NAME[selectedView];
  const lastUrlParam = window.location.pathname.split("/").slice(3);

  return (
    <Breadcrumbs>
      <BreadcrumbItem label="Projects" onClick={handleWorkspacesClick} />
      {workspace === null ? (
        <Skeleton width={110} />
      ) : (
        <BreadcrumbItem
          id="breadcrumb-workspace-name"
          label={workspace?.name || ""}
          onClick={handleWorkspaceClick}
        />
      )}

      {lastUrlParam.length > 0 ? (
        lastUrlParam.map((param, index) => (
          <BreadcrumbItem
            key={index}
            label={PATH_BREADCRUMB_MAP[param] || param}
            onClick={() => {
              if (param === "configuration") {
                navigate(
                  `/projects/${workspace?.id}/configuration/market-sizing`
                );
              }
            }}
          />
        ))
      ) : (
        <BreadcrumbItem
          label={
            PATH_BREADCRUMB_MAP[lastBreadcrumbLabel] || lastBreadcrumbLabel
          }
        />
      )}
    </Breadcrumbs>
  );
};
